import Fetch from '../utils/fetch';
import { settings } from '../settings';

export async function fetchLabelsAsZPL(orderIds: string[]): Promise<Blob> {
  const response = await Fetch.get({
    url: `${
      settings.newApiUrl
    }/order/labels?orderIds=${orderIds.join()}&addShelfIds=true`,
    headers: {
      Accept: 'application/zpl',
    },
  });
  return response.blob();
}
